// the starting point for your redux store
// this defines what your store state will look like
import { combineReducers } from 'redux';

import SurveyReducer from './survey-reducer';
import UserReducer from './user-reducer';
import ResultReducer from './result-reducer';
import FavoritesReducer from './favorites-reducer';
import ResponseReducer from './response-reducer';
import ModalReducer from './modal-reducer';
import SpeechReducer from './speech-reducer';
import PasswordReducer from './password-reducer';
import BeelineReducer from './beeline-reducer';

const reducer = combineReducers({ // Combines all reducers
  survey: SurveyReducer,
  user: UserReducer,
  result: ResultReducer,
  favorites: FavoritesReducer,
  response: ResponseReducer,
  modal: ModalReducer,
  speech: SpeechReducer,
  password: PasswordReducer,
  beeline: BeelineReducer,
});

export default reducer;
